
import { defineComponent, PropType } from 'vue'
import { mapActions } from 'vuex'
import { OrgUsersActions } from '~/store/control-panel/users'
import { EnterpriseUser } from '~/types/types'
import MutationFailedError from '~/utils/mutationFailedError'

export default defineComponent({
  name: 'DeleteUserButton',
  props: {
    orgUser: {
      type: Object as PropType<EnterpriseUser>,
      required: true
    }
  },
  data() {
    return {
      showDeleteUserConfirm: false,
      isDeletingUser: false
    }
  },
  methods: {
    ...mapActions('control-panel/users', {
      deleteUserFromOrg: OrgUsersActions.DELETE_USER
    }),
    showConfirm() {
      this.showDeleteUserConfirm = true
    },
    async deleteUser(userId: string, close?: () => void) {
      this.isDeletingUser = true
      try {
        const response = await this.deleteUserFromOrg({ userId })
        if (!response) {
          throw new MutationFailedError('An error occured while deleting user, please try again.')
        }
        this.$toast.success('User deleted succesfully.')
        if (close) close()
        this.$router.push('/control-panel/user-management')
      } catch (e) {
        this.$toast.danger((e as Error).message)
        this.$emit('refetch')
        if (close) close()
      } finally {
        this.isDeletingUser = false
      }
    }
  }
})
